<button mat-button class="expand-button" (click)="toggleExpanded()">
  <mat-icon class="expand-button__icon">{{ isExpanded() ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>

  @if (isExpanded()) {
    weniger anzeigen
  } @else {
    {{ hiddenElementsCount() }} weitere anzeigen
  }
</button>
